import { hubbleAPI } from './url'
const resource = hubbleAPI + 'public/ct'
export default ($axios) => ({
  getPlayMixServices(bundleId) {
    return $axios.get(`${resource}/subscription/telmore-mix/${bundleId}`)
  }
})
